import Vue from "vue";
import App from "./component/app.vue";
import store from "./store";
import router from "./route";
import axios from "axios";
import VueAxios from "vue-axios";
import VueEvents from "vue-events";
import VueAuth from "@websanova/vue-auth";
import VueLocalStorage from "vue-localstorage";
import VueMaterial from "vue-material";
import VueQuillEditor from "vue-quill-editor";
import moment from "moment";
import * as VueGoogleMaps from "vue2-google-maps";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
import BootstrapVue from "bootstrap-vue";
import Multiselect from "vue-multiselect";

Vue.use(BootstrapVue);
Vue.use(Multiselect);

import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

// import VueGoogleCharts from "vue-google-charts";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

//import styles
import "../node_modules/vue-material/dist/vue-material.css";
import "./style/app.css";
import "vue-trix";

//specify your base and end point url to started.
import { URL_BASE } from "./helper/constant";
import Vuelidate from "vuelidate";
global.eventBus = new Vue();
const loginUrl = `${URL_BASE}/dashboard/login`;
const fetchUserUrl = `${URL_BASE}/auth/userDeatils`;

//define this before using vue-auth and comment this if your dashboard doesn't require any authentication
Vue.router = router;
Vue.use(VueQuillEditor /* { default global options } */);
Vue.use(VueMaterial);
Vue.use(VueAxios, axios);
Vue.use(VueLocalStorage, {
  name: "sessionsStorage",
});
Vue.use(Vuelidate);
Vue.use(VueEvents);
// Vue.use(FormInput);
// Vue.use(FormFile);
// Vue.use(FormTextarea);
// Vue.use(FormRadio);
// Vue.use(VueGoogleCharts);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCsAiATFqYZMWOxKIwhUbPUaEKjNpnh2Y8",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});
import CommonService from "./services/CommonService";

Vue.mixin({
  methods: {
    capitalizeFirstLetter: (str) => str.charAt(0).toUpperCase() + str.slice(1),
    capitalizeAll: (str) => str.toUpperCase(),
    async getSignedDocumentUrl(key) {
      if (!key) return null;
      if (key.startsWith("http")) return key;

      try {
        let payload = { key: key };
        let result = await CommonService.getCommonSignedUrl(payload);
        const { data } = result;

        if (data.status === "success" && data.url) {
          return data.url;
        }
      } catch (error) {
        console.error("Error getting signed URL:", error);
      }
      return null;
    },
    async openSignedDocument(key) {
      if (!key) return;

      // If it's already a full URL (legacy/public), just open it
      if (key.startsWith("http")) {
        window.open(key, "_blank");
        return;
      }

      try {
        let payload = { key: key };
        let result = await CommonService.getCommonSignedUrl(payload);
        const { data } = result;

        if (data.status === "success" && data.url) {
          window.open(data.url, "_blank");
        } else {
          console.error("Failed to get signed URL:", data.message);
          // Fallback: try opening as a direct link (legacy behavior)
          // window.open(`${URL_BASE_DOC}/${key}`, "_blank");
          alert("Could not open document. Please contact support.");
        }
      } catch (error) {
        console.error("Error opening signed document:", error);
        alert("Error opening document.");
      }
    },
  },
});

Vue.config.devtools = true;
//now create new vue instance and stick it over app(defined in index.html)

new Vue({
  el: "#app",
  store: store,
  router: router,
  render: (render) => render(App),
});



// WEBPACK FOOTER //
// ./src/main.js